import { useMutation } from '@tanstack/react-query';
import { customFetcher } from '../useFetch';
import { IAdminstrativeUnitFullObject } from '../../Interfaces/IAdminstrativeUnit';

export const useUpdateAdministrativeUnitFullObject = () => {
  const {
    mutateAsync: updateAdministrativeUnitFullObject,
    isPending: isPendingUpdateAdministrativeUnitFullObject,
  } = useMutation({
    mutationFn: (currentObject: IAdminstrativeUnitFullObject) =>
      customFetcher({
        endpoint: '/administrativeunit/fullObject',
        method: 'PUT',
        body: currentObject,
      }),
  });
  return {
    updateAdministrativeUnitFullObject,
    isPendingUpdateAdministrativeUnitFullObject,
  };
};
